import { DoorFormValues, isHeaderRowEmpty } from './doorAccessMapping';

export const DOOR_ERRORS = {
  URL_REQUIRED: 'The URL field is mandatory.',
  URL_PROTOCOL: 'The URL must start with http:// or https://.',
  BODY_JSON: 'The body is not valid JSON.',
  HEADER_KEY: 'The header key is mandatory.',
  HEADER_VALUE: 'The header value is mandatory.',
  DEVICE_ID_REQUIRED: 'The Device ID field is mandatory.',
  DEVICE_ID_FORMAT: 'The Device ID may only have letters, digits, \'_\' and \'-\'.',
} as const;

interface DoorHeaderRowErrors {
  key?: string;
  value?: string;
}

export interface DoorFormErrors {
  url?: string;
  deviceId?: string;
  body?: string;
  headers?: (DoorHeaderRowErrors | undefined)[];
}

const URL_PATTERN = /^https?:\/\/\S+$/i;
// Mesmo padrão do CS: vira routing key na exchange topic, sem '.'
const DEVICE_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

export const bodyForJsonCheck = (body: string): string =>
  body
    .replace(/\{connectorId\}/g, '1')
    .replace(/\{(stationId|requestId)\}/g, 'x');

export const validateDoorForm = (values: DoorFormValues): DoorFormErrors => {
  const errors: DoorFormErrors = {};
  if (!values.enabled) return errors;

  const moveIot = values.transport === 'MOVE_IOT';
  if (moveIot) {
    const deviceId = values.deviceId.trim();
    if (!deviceId) errors.deviceId = DOOR_ERRORS.DEVICE_ID_REQUIRED;
    else if (!DEVICE_ID_PATTERN.test(deviceId))
      errors.deviceId = DOOR_ERRORS.DEVICE_ID_FORMAT;
  } else {
    const url = values.url.trim();
    if (!url) errors.url = DOOR_ERRORS.URL_REQUIRED;
    else if (!URL_PATTERN.test(url)) errors.url = DOOR_ERRORS.URL_PROTOCOL;
  }

  // movE IoT: o CS monta o comando de destravar, não há corpo nem headers a validar
  if (moveIot) return errors;

  if (values.body.trim()) {
    try {
      JSON.parse(bodyForJsonCheck(values.body));
    } catch (error) {
      errors.body = DOOR_ERRORS.BODY_JSON;
    }
  }

  const headerErrors = values.headers.map(
    (row): DoorHeaderRowErrors | undefined => {
      if (isHeaderRowEmpty(row)) return undefined;
      if (!row.key.trim()) return { key: DOOR_ERRORS.HEADER_KEY };
      if (!row.value.trim()) return { value: DOOR_ERRORS.HEADER_VALUE };
      return undefined;
    },
  );
  if (headerErrors.some(Boolean)) errors.headers = headerErrors;

  return errors;
};

export const hasDoorErrors = (errors: DoorFormErrors): boolean =>
  Object.keys(errors).length > 0;
